export const userGraphicalReport = {
  inputField: (formArgs) => [
    {
      key: 1,
      isMulti: true,
      type: "multiSelect",
      isRequired: true,
      name: "userSelect",
      label: "Select Users",
      isLimit: true,
      defaultValue: formArgs.selectedUser,
      placeholder: "Select User Groups",
      options: formArgs.userOptions,
      onChange: (e) => formArgs.onSelectedUserSelected(e),
      maxSelected: 5,
      validationLabel: "Users",
      selectedValue: formArgs.selectedUser,
    },
    {
      key: 2,
      label: "From Date",
      type: "date",
      isFromDate: true,
      //   isRquired: true,
      onChange: (e) => formArgs.onFromDateChange(e),
    },
    {
      key: 3,
      label: "To Date",
      type: "date",
      //   isRequired: true,
      //   isLimit: true,
      //   maxSelected: 90,
      //   validationLabel: "Days",
      min: formArgs.fromDate,
      onChange: (e) => formArgs.onToDateChange(e),
    },

    {
      key: 4,
      isMulti: true,
      type: "multiSelect",
      //   isRequired: true,
      name: "trainingType",
      label: "Training Type",
      isLimit: true,
      defaultValue: formArgs.selectedTraining,
      placeholder: "Select Training",
      options: formArgs.trainingTypeOptions,
      onChange: (e) => formArgs.onTrainingSelected(e),
      maxSelected: 15,
      validationLabel: "Trainings ",
      selectedValue: formArgs.selectedTraining,
    },
    {
      key: 5,
      type: "searchBtn",
      isCombine: true,
      onClick: (e) => formArgs.handleReset(e),
    },
    {
      key: 6,
      type: "searchBtn",
      isCombine: false,
      onClick: (e) => formArgs.onFilterSearch(e),
    },
  ],
  graphs: (data1, data2, data3, data4, data5) => [
    {
      key: 1,
      type: "doughnut",
      heading: "Distribution Summary",
      xAxesText: "",
      yAxesText: "",
      data: data1,
    },
    {
      key: 2,
      type: "lineGraph",
      heading: "Shotclass Completion Trend",
      xAxesText: "Distribution Count",
      yAxesText: "Assigned Date (dd-mm-yyyy)",
      data: data2,
    },
    {
      key: 3,
      type: "verticalBar",
      heading: "Top 10 Most Rated",
      xAxesText: "LoginId",
      yAxesText: "Passed Count",
      data: data3,
    },
    {
      key: 4,
      type: "verticalBar",
      heading: "Top 10 Most Passed",
      xAxesText: "LoginId",
      yAxesText: "Passed Count",
      data: data4,
    },
    {
      key: 5,
      type: "verticalBar",
      heading: "Top 10 Most Credit",
      xAxesText: "LoginId",
      yAxesText: "Credit Count",
      data: data5,
    },
  ],
};
